import React, { useEffect, useMemo, useState } from 'react';
import './sideFilterTree.less';
import { SideFilterAttr, TreeFilter } from '../../interface';
import { Cascader, Menu, Skeleton } from 'antd';
// import type { CascaderProps, GetProp } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../../store/store';
import { updateModalSideFilters, updateSiteFilter } from '../../../../modules/SearchDatePicker/searchDatePickerSlice';
import useGetAttributeTranslation from '../../hooks/useGetAttributeTranslation';
import useAttractionTreeFilters from './useAttractionTreeFilters';
import { debounce } from 'lodash';

// type DefaultOptionType = GetProp<CascaderProps, 'options'>[number];

interface TreeFilterType {
  key: string;
  label: string;
  children?: TreeFilterType[] | undefined;
}
interface Props {
  filter: TreeFilter;
  withModalScopeParams?: boolean;
  isLoading?: boolean;
  additionalPrice?: number;
    localSideFilters?: Record<string, any> | null;
  setLocalSideFilters?: (f: Record<string, any>) => void;
}

const SideFilterTree = ({ filter, withModalScopeParams, isLoading, additionalPrice = 0 ,localSideFilters,setLocalSideFilters }: Props) => {
  const dispatch = useDispatch();
  const { sideFilters: reduxSideFilters, modalSideFilters } = useSelector(
    (state: RootState) => {
      return state.search;
    }
  );
  const sideFilters = useMemo(
    () => (localSideFilters ? localSideFilters : withModalScopeParams
      ? modalSideFilters
      : reduxSideFilters),
    [withModalScopeParams, modalSideFilters, reduxSideFilters, localSideFilters]
  );
  const { general: t, attractions: t_attractions } = useSelector(
    (state: RootState) => state.config.translations
  );

  const attributeTranslation = useGetAttributeTranslation();
  const treeFilter = useAttractionTreeFilters();

  // helper to commit change either to local state or to redux
  const commitFilter = (key: string, value: any) => {
    if (typeof setLocalSideFilters === 'function') {
      setLocalSideFilters({
        ...(localSideFilters || {}),
        [key]: value,
      });
      return;
    }
    const fn = withModalScopeParams ? updateModalSideFilters : updateSiteFilter;
    dispatch(fn({ key, value }));
  };

  // Menu onClick payload: { key, keyPath, domEvent, item, ... }
  const handleChange = (info: any) => {
    const newKey = info?.key;
    if (newKey === undefined || newKey === null) return;

    const prev: any[] = Array.isArray(sideFilters?.[filter.attr])
      ? sideFilters[filter.attr]
      : [];

    const updated =
      prev.includes(newKey) ? prev.filter((k) => k !== newKey) : [...prev, newKey];

    commitFilter(filter.attr, updated);
  };

  if (isLoading) {
    return <Skeleton active paragraph={{ rows: 1 }} />;
  }

  return (
    <div className="side-filter-tree">
      <h2>{attributeTranslation(filter.attr)}</h2>
      {treeFilter && (
        <Menu
          multiple
          items={treeFilter}
          selectedKeys={sideFilters?.[filter.attr]}
          // onSelect={handleChange}
          onClick={handleChange}
          mode={'inline'}
        />
      )}
    </div>
  );
};

export default SideFilterTree;
